if (!customElements.get('feature-cards-carousel')) {
  class FeatureCardsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.swipe-mobile');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.prevButton || !this.nextButton) return;

      this.initEvents();
      // Wait a tick for CSS to apply and layout to calculate
      setTimeout(() => this.updateButtonVisibility(), 100);
    }

    initEvents() {
      this.prevButton.addEventListener('click', this.scroll.bind(this, 'prev'));
      this.nextButton.addEventListener('click', this.scroll.bind(this, 'next'));
      this.slider.addEventListener('scroll', this.updateButtonVisibility.bind(this), { passive: true });
      window.addEventListener('resize', this.updateButtonVisibility.bind(this));
      
      const observer = new ResizeObserver(() => this.updateButtonVisibility());
      observer.observe(this.slider);
    }

    scroll(direction) {
      const card = this.slider.querySelector('.f-column');
      if (!card) return;
      
      const gap = parseInt(window.getComputedStyle(this.slider).gap) || 0;
      const scrollAmount = card.clientWidth + gap;
      
      this.slider.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }

    updateButtonVisibility() {
      if (this.slider.scrollLeft <= 0) {
        this.prevButton.classList.add('opacity-0', 'pointer-events-none');
      } else {
        this.prevButton.classList.remove('opacity-0', 'pointer-events-none');
      }

      if (this.slider.scrollLeft + this.slider.clientWidth >= this.slider.scrollWidth - 1) {
        this.nextButton.classList.add('opacity-0', 'pointer-events-none');
      } else {
        this.nextButton.classList.remove('opacity-0', 'pointer-events-none');
      }
    }
  }

  customElements.define('feature-cards-carousel', FeatureCardsCarousel);
}
